import { render, staticRenderFns } from "./IHaveComplaint.vue?vue&type=template&id=74133933&scoped=true&"
import script from "./IHaveComplaint.vue?vue&type=script&lang=js&"
export * from "./IHaveComplaint.vue?vue&type=script&lang=js&"
import style0 from "./IHaveComplaint.vue?vue&type=style&index=0&id=74133933&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74133933",
  null
  
)

export default component.exports